import { get } from 'lodash';
import { getBlogSettings, updateBlogSettings, } from '@wix/ambassador-blog-settings-v2-blog-settings/http';
import createAction from '../../services/create-action';
import { getDefaultSiteLocale, getLocales, } from '../multilingual-locales/selectors';
import { FALLBACK_TPA_SETTINGS } from './fallback-tpa-settings';
import { getTPASettingsData } from './tpa-settings-selectors';
const config = {
    apiBaseUrl: '/_api/app-settings-service',
};
export const fetchTPASettingsRequest = createAction('tpaSettings/FETCH_SETTINGS_REQUEST');
export const fetchTPASettingsSuccess = createAction('tpaSettings/FETCH_SETTINGS_SUCCESS', (payload) => payload);
export const fetchTPASettingsFailure = createAction('tpaSettings/FETCH_SETTINGS_FAILURE');
export const fetchTPASettings = ({ host = 'NA', state = 'PUBLISHED', language, shouldUseV2, shouldUseFallbackOnError, } = {}) => async (dispatch, getState, { request, httpClient }) => {
    dispatch(fetchTPASettingsRequest());
    const languageCode = language ||
        (getLocales(getState()) &&
            get(getDefaultSiteLocale(getState()), 'id', null));
    try {
        if (shouldUseV2) {
            try {
                const response = await httpClient.request(getBlogSettings({ language: languageCode }));
                dispatch(fetchTPASettingsSuccess({
                    settings: response.data.blogSettings,
                }));
                return { settings: response.data.blogSettings };
            }
            catch (error) {
                if (shouldUseFallbackOnError) {
                    dispatch(fetchTPASettingsSuccess({
                        settings: FALLBACK_TPA_SETTINGS,
                    }));
                    return { settings: FALLBACK_TPA_SETTINGS };
                }
                else {
                    throw error;
                }
            }
        }
        else {
            const response = await request(`/v1/settings/instances?state=${state}&host=${host}${languageCode ? `&languageKey.languageCode=${languageCode}` : ''}`, config);
            const successPayload = {
                settings: response.settings,
                ...(languageCode && {
                    translations: { [languageCode]: response.translations },
                }),
            };
            dispatch(fetchTPASettingsSuccess(successPayload));
            return successPayload;
        }
    }
    catch (error) {
        dispatch(fetchTPASettingsFailure());
        throw error;
    }
};
export const updateTPASettingsRequest = createAction('tpaSettings/UPDATE_SETTINGS_REQUEST');
export const updateTPASettingsSuccess = createAction('tpaSettings/UPDATE_SETTINGS_SUCCESS', (payload) => payload);
export const updateTPASettingsFailure = createAction('tpaSettings/UPDATE_SETTINGS_FAILURE');
export const updateTPASettings = ({ settings, language }) => async (dispatch, getState, { httpClient }) => {
    dispatch(updateTPASettingsRequest());
    try {
        const response = await httpClient.request(updateBlogSettings({
            blogSettings: {
                ...(settings || getTPASettingsData(getState())),
                revision: getState().tpaSettings.settings.revision,
            },
            language,
        }));
        dispatch(updateTPASettingsSuccess({
            settings: response.data.blogSettings,
        }));
    }
    catch (error) {
        dispatch(updateTPASettingsFailure());
    }
};
//# sourceMappingURL=tpa-settings-actions.js.map